import React from "react";
import { connect } from "react-redux";
import { prefillRenter } from "@cb/duck/renter";
import { prefillCoRenter } from "@cb/duck/coRenter";
import { Button } from "semantic-ui-react";

function Prefiller(props) {
  return (
    <Button
      content="Prefill Renter Data"
      basic
      size="mini"
      onClick={(e) => props.prefillRenter(props.id, props.renter.id)}
      style={{ marginBottom: "10px" }}
    />
  );
}

function mapStateToProps(state) {
  return {
    coRenter: state.coRenter,
    id: state.id,
    renter: state.renter,
  };
}

const mapDispatchToProps = (dispatch) => ({
  prefillRenter: (contractId, renterId) =>
    dispatch(prefillRenter(contractId, renterId)),
  prefillCoRenter: (contractId, renterId) =>
    dispatch(prefillCoRenter(contractId, renterId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Prefiller);
